import { render } from "./TournamentPage.vue?vue&type=template&id=16812a28&scoped=true"
import script from "./TournamentPage.vue?vue&type=script&lang=js"
export * from "./TournamentPage.vue?vue&type=script&lang=js"

import "./TournamentPage.vue?vue&type=style&index=0&id=16812a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16812a28"]])

export default __exports__